// Molecules - комбінації атомів
export { default as Logo } from './Logo';
export { default as Badge } from './Badge';
export { default as StatCard } from './StatCard';
export { default as SocialLink } from './SocialLink';
export { default as SectionHeader } from './SectionHeader';
export { default as SectionCard } from './SectionCard';
export { default as CtaBlock } from './CtaBlock';
export { default as QuoteBlock } from './QuoteBlock';
export type { LogoProps } from './Logo/types';
export type { BadgeProps } from './Badge/types';
export type { StatCardProps } from './StatCard/types';
export type { SocialLinkProps } from './SocialLink/types';
export type { SectionHeaderProps } from './SectionHeader/types';
export type { SectionCardProps } from './SectionCard/types';
export type { CtaBlockProps } from './CtaBlock/types';
export type { QuoteBlockProps } from './QuoteBlock/types';
